import { isLeaderboardTvSurface } from './app/components/leaderboards/tv-host.guard';

declare const ngDevMode: boolean | undefined;

/**
 * [AE-4721] Floor TVs boot a slim shell; everyone else gets the dialer.
 * Both graphs must be dynamic imports so they do not share one chunk.
 *
 * A failed chunk otherwise leaves a blank screen with no clue which
 * surface degraded, so name it: console is all that is guaranteed here,
 * before either bootstrap has wired up a logger or Sentry.
 */
if (isLeaderboardTvSurface()) {
  void import('./app/tv/tv.bootstrap').catch(error => {
    console.error('[AE-4721] TV shell failed to load', error);
  });
} else {
  void loadDialer();
}

// [AE-5724] ng serve leaves @ngrx/store unlinked. JIT only while ngDevMode is on.
async function loadDialer(): Promise<void> {
  try {
    if (typeof ngDevMode === 'undefined' || ngDevMode) {
      await import('@angular/compiler');
    }
    await import('./app/dialer.bootstrap');
  } catch (error) {
    console.error('[AE-4721] Dialer shell failed to load', error);
  }
}
